// 按需引入antDesign组件
import Vue from 'vue'
import {
  Button,
  Input,
  Form,
  Checkbox,
  Icon,
  message,
  Carousel,
  Cascader,
  InputNumber,
  Table,
  Popconfirm,
  Steps,
  Spin,
  Card,
  Divider,
  Tabs,
  Modal,
  Upload,
  Select,
  Radio,
  Breadcrumb,
  Tag,
  Alert,
  Dropdown,
  Menu,
  Empty,
  Pagination,
  Tooltip,
  FormModel,
  Row,
  Col
} from 'ant-design-vue'

Vue.use(Row)
Vue.use(Col)
Vue.use(FormModel)
Vue.use(Spin)
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Input)
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Carousel)
Vue.use(Cascader)
Vue.use(InputNumber)
Vue.use(Table)
Vue.use(Popconfirm)
Vue.use(Steps)
Vue.use(Card)
Vue.use(Divider)
Vue.use(Tabs)
Vue.use(Modal)
Vue.use(Select)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(Breadcrumb)
Vue.use(Tag)
Vue.use(Alert)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Empty)
Vue.use(Tooltip)

Vue.prototype.$message = message
Vue.prototype.$confirm = Modal.confirm
